import {Store,Module,ActionContext} from 'vuex'
import {ListStateItem, ListModuleItem} from '@/store/shared/index'
import Tenant from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

interface TenantState extends ListStateItem<Tenant>{
    editTenant:Tenant;
}
class TenantModule extends ListModuleItem<TenantState,any,Tenant>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editTenant:new Tenant()
    }

    actions={
        async getAll(context:ActionContext<TenantState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/Tenant/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<Tenant>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<TenantState,any>,payload:any){
            await $http.post('services/app/Tenant/Create',payload.data);
        },
        async update(context:ActionContext<TenantState,any>,payload:any){
            await $http.put('services/app/Tenant/Update',payload.data);
        },
        async delete(context:ActionContext<TenantState,any>,payload:any){
            await $http.delete('services/app/Tenant/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<TenantState,any>,payload:any){
            let reponse=await $http.get('services/app/Tenant/Get?Id='+payload.id);
            return reponse.data.result as Tenant;
        }
    };
    overrideMutations={
        edit(state:TenantState,tenant:Tenant){
            state.editTenant=tenant;
        }
    }
}
const tenantModule=new TenantModule();
export default tenantModule;